import { useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'

export type ArchiveTemplateModalProps = {
  open: boolean
  handleClose: VoidFunction
  handleArchive: VoidFunction
  isLoading: boolean
}

export function ArchiveTemplateModal({
  open,
  handleClose,
  handleArchive,
  isLoading
}: Readonly<ArchiveTemplateModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose} data-testid="archive-template-modal">
      <ActionModal
        title={t('dialog.templates.archive.title')}
        primaryButtonText={t('button.archiveTemplate')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={handleArchive}
        loading={isLoading}
      >
        {t('dialog.templates.archive.description')}
      </ActionModal>
    </Modal>
  )
}
